// Component VERSIONS client — one history surface for every first-class
// component (apps, agents, models, workflows).
//
// Apps, agents and models ARE Flow endpoints on the project's paired fork, so
// their history is the fork's git commits (every export commits to a durable
// local repo — no remote needed). Workflows are pg rows instead, so the backend
// routes them to the process engine's own version table. Both shapes come back
// through the same calls, which is why the UI panel is shared.
import { fetchData } from '../fetchapi/fetchapi';

// `projectSlug` targets a project other than the active one (the Projects page
// lists every project, so its history rows are not necessarily the active one).
// Omit it and the backend falls back to the URL/JWT project as usual.
const json = (body, projectSlug) => ({
  method: 'POST',
  headers: {
    'Content-Type': 'application/json',
    ...(projectSlug ? { 'X-Cortex-Project': projectSlug, 'X-Cortex-Branch': 'main' } : {}),
  },
  body: JSON.stringify(body),
});

// kind: 'app' | 'agent' | 'model' | 'workflow'
// name: the component's identifying name — for apps that is the *.view endpoint
//       name; for agents/models the bare name; for workflows the definition id.
export async function listVersions({ kind, name, branch, projectSlug } = {}) {
  return fetchData('versions/list', json({ kind, name, ...(branch ? { branch } : {}) }, projectSlug));
}

// Full per-node diff for one version: what restoring it would change.
export async function getVersionDiff({ kind, name, commitHash, version, projectSlug } = {}) {
  return fetchData('versions/diff', json({
    kind, name,
    ...(commitHash ? { commitHash } : {}),
    ...(version != null ? { version } : {}),
  }, projectSlug));
}

export async function listVersionBranches() {
  return fetchData('versions/branches', json({}));
}

// Scope follows the kind: app/agent/model restore ONLY that object; a workflow
// restores through the process engine (by version, appending a new one); a
// PROJECT restore rewrites the whole fork, which is the only case that needs
// `acknowledge`.
export async function restoreVersion({ kind, name, commitHash, version, acknowledge, projectSlug } = {}) {
  return fetchData('versions/restore', json({
    kind, name,
    ...(commitHash ? { commitHash } : {}),
    ...(version != null ? { version } : {}),
    ...(acknowledge ? { acknowledge_project_wide: true } : {}),
  }, projectSlug));
}
